import React from "react";
import './Login.css'
import { Link } from "react-router-dom";
import logo from '../images/logo.png'

function SignUp (){


    return(
        <div className="login">
            <div className="container">
                <div className="logo">
                    <img src={logo} />
                    <h2>D-Clinic</h2>
                </div>
                <form>
                     <div className="form">
                        <input placeholder="Name" type="text"required/>
                    </div>
                    <div className="form">
                        <input placeholder="Email" type="email"required/>
                    </div>
                    <div className="form">
                        <input placeholder="Username" type="text"required/>
                    </div>
                    <div className="form">
                        <input placeholder="Password" type="password"required/>
                    </div>
                    <Link to="/home" ><button className="btn1">Sign Up</button></Link>
                    <br/>
                    <p>Already have an account?</p>
                    <Link to="/login" ><button className="btn2">Login</button></Link>
                </form>
            </div>
        </div>
    )
}
export default SignUp;
